import React from 'react'
import AnimateImageTwo from './AnimateImageTwo'
import AnimateTitleTwo from './AnimatedTitleTwo'

const EmbroideryUnit = () => {
    return (
        <section className='section-embroidery-unit section-padding'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-8'>
                    <div className='section-img-heading'>
                    <div className='animated-image-wrapper'>
                        <AnimateImageTwo/>
                    </div>
                    <div className='section-title'>
                        <AnimateTitleTwo/>
                     </div>
                     </div>
                </div>
                <div className='col-md-4'>
                   <div className='section-content-wrapper'>
                     <div className='section-paragraph'>
                        <p>Born from a vision to elevate the intricate art of Indian hand embroidery, <strong>India Embroidery Co.</strong> has evolved into a name synonymous with refinement and creativity. Founded in the early 2000s in Mumbai, we set out to blend India’s rich embroidery heritage with contemporary design aesthetics that resonate with the international fashion industry.</p>
                        <p>Over the years, our creations have graced the ateliers of leading prêt-à-porter and haute couture houses around the world.</p>
                        <p>In 2013, our journey took a natural leap forward as <strong>India Embroidery Co</strong> our garmenting division, was established — offering complete end-to-end production solutions. Today, we stand as a full-fledged design and manufacturing house known for our finesse, precision, and ability to transform imagination into exquisite craftsmanship.</p>
                     </div>
                   </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default EmbroideryUnit